import ReferralTermsAr from "@components/ReferralTermsAndConditions/ReferralTermsAr";
import ReferralTermsEn from "@components/ReferralTermsAndConditions/ReferralTermsEn";

interface ReferralTermAndConditionsProps {
  locale: string;
  referrals: SiteConfigReferrals;
  withdrawalMethods: WithdrawalMethods;
}

const ReferralTermAndConditions: React.FC<ReferralTermAndConditionsProps> = ({
  locale,
  referrals,
  withdrawalMethods,
}) => {
  const { referralPayout } = referrals || {};

  switch (locale) {
    case "ar":
      return (
        <ReferralTermsAr
          referralPayout={referralPayout}
          withdrawalMethods={withdrawalMethods}
        />
      );
      break;
    default:
    case "en":
      return (
        <ReferralTermsEn
          referralPayout={referralPayout}
          withdrawalMethods={withdrawalMethods}
        />
      );
      break;
  }
};

export default ReferralTermAndConditions;
